import "../styles/Webdesign.scss";
import useLightbox from "../hooks/useLightbox";
import webdesign from "../assets/webdesign2.png";
import Zoom from "react-reveal/Zoom";
import img02 from "../assets/webdesigns/revanove-webdesign-01.jpg";
import img01 from "../assets/covers/revanove-webdesign.jpg";
import img03 from "../assets/covers/logo-rond.jpg";
import img04 from "../assets/webdesigns/webdesign-10-21.png";
import img05 from "../assets/covers/eyeka-2018.jpg";
import img06 from "../assets/webdesigns/eyeka-webdesign-2018.jpg";
import img07 from "../assets/webdesigns/eyeka-webdesign-2018-01.jpg";
import img08 from "../assets/webdesigns/eyeka-webdesign-2018-02.jpg";
import img09 from "../assets/webdesigns/eyeka-webdesign-2018-03.jpg";
import img10 from "../assets/covers/eyeka-2015.jpg";
import img11 from "../assets/webdesigns/fabien-bazire (5).jpg";
import img12 from "../assets/webdesigns/fabien-bazire (6).jpg";
import img13 from "../assets/webdesigns/fabien-bazire (7).jpg";
import img14 from "../assets/webdesigns/fabien-bazire (8).jpg";
import img15 from "../assets/covers/bushcraft.png";
import img16 from "../assets/webdesigns/bushcraft-webdesign-01.jpg";
import img17 from "../assets/covers/webdesign-m&t.jpg";
import img18 from "../assets/webdesigns/Margot&Tita-webdesign.jpg";
import img19 from "../assets/covers/lawebbisterie-webdesign.jpg";
import img20 from "../assets/webdesigns/lawebbisterie-webdesign-01.jpg";
import img20bis from "../assets/webdesigns/lawebbisterie-webdesign-02.jpg";
import img21 from "../assets/covers/oceansfishing-logo.jpg";
import img22 from "../assets/webdesigns/oceaning webdesign.jpg";
import img23 from "../assets/covers/travelmania.png";
import img24 from "../assets/webdesigns/webdesign-travelmania.jpg";
import img27 from "../assets/covers/webdesign-sylmaps.png";
import img28 from "../assets/webdesigns/sylmaps-webdesign-01.jpg";
import img29 from "../assets/covers/vitalecode.png";
import img30 from "../assets/webdesigns/webdesign-vitalcode.jpg";
import img31 from "../assets/webdesigns/presentation-flyer-vitale-code.jpg";
import { GlitchImage } from "react-glitch-image";

const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

const ALL_CARDS = shuffle([
  { title: "poke'n go",       cover: img03, supImgs: [img04] },
  { title: "revanove",        cover: img01, supImgs: [img02] },
  { title: "eyeka!",          cover: img05, supImgs: [img06, img07, img08, img09] },
  { title: "eyeka",           cover: img10, supImgs: [img11, img12, img13, img14] },
  { title: "Margot & Tita",   cover: img17, supImgs: [img18] },
  { title: "La Webbisterie",  cover: img19, supImgs: [img20, img20bis] },
  { title: "Oceans Fishing",  cover: img21, supImgs: [img22] },
  { title: "Travel Mania",    cover: img23, supImgs: [img24] },
  { title: "Sylmaps",         cover: img27, supImgs: [img28] },
  { title: "Bushcraft leblog", cover: img15, supImgs: [img16] },
  { title: "Vital eCode",     cover: img29, supImgs: [img30, img31] },
]);

const Webdesign = () => {
  const { lightbox, visible, openLightbox, closeLightbox } = useLightbox();

  return (
    <div className="boxWebdesign">
      <section id="sectionWebdesign"></section>
      <div className="boxTitle">
        <GlitchImage image={webdesign} alt="imgWebdesign" className="imgWebdesign"/>
      </div>

      {ALL_CARDS.map(({ title, cover, supImgs }, i) => (
        <Zoom key={i}>
          <div className="boxText">
            <h1>{title}</h1>
            <div className="gridContainer">
              <div className="overlay">
                <div className="boxSupImg">
                  {supImgs.map((src, j) => (
                    <img
                      key={j}
                      src={src}
                      className="supImg"
                      alt=""
                      style={{ cursor: "pointer" }}
                      onClick={(e) => { e.stopPropagation(); openLightbox(src); }}
                    />
                  ))}
                </div>
              </div>
              <img src={cover} alt="" className="imgGrid" />
            </div>
          </div>
        </Zoom>
      ))}

      {lightbox && (
        <div className={`lightbox${visible ? " lightbox--visible" : ""}`} onClick={closeLightbox}>
          <img src={lightbox} alt="" className="lightbox__img" onClick={closeLightbox} />
        </div>
      )}
    </div>
  );
};

export default Webdesign;
